'use client';

import { Switch } from '../../components/switch';
import { BodyDefault } from '../../components/typography';

export type ListPageOptionsSwitchProps = {
  label: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
};

export function ListPageOptionsSwitch({
  label,
  checked,
  onCheckedChange,
  disabled,
}: ListPageOptionsSwitchProps) {
  return (
    <Switch
      size="sm"
      checked={checked}
      disabled={disabled}
      onCheckedChange={(details) => onCheckedChange(details.checked)}
      flexDirection="row-reverse"
      justifyContent="space-between"
      alignItems="center"
      gap="2"
      w="full"
      p="2"
      borderRadius="l1"
    >
      <BodyDefault flex="1">{label}</BodyDefault>
    </Switch>
  );
}
